import { Button, Col, Input, Row } from 'antd';
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FormattedMessage } from 'react-intl';
import { StyledAlert, Title } from './style';

interface Props {
  apiKey: string;
  onClose: Function;
}

const GeneratedAPIKeyInstance = ({ apiKey, onClose }: Props) => {
  const [isAPIKeyCopied, setIsAPIKeyCopied] = useState(false);

  return (
    <>
      <Title>
        <FormattedMessage id="ApiKeys.modal.apiKeygenerate.title" />
      </Title>
      <p>
        <FormattedMessage id="ApiKeys.GenerateApikeyModal.subTitle" />
      </p>

      <Row gutter={[10, 0]}>
        <Col span={19}>
          <Input
            value={apiKey}
            onCopy={() => setIsAPIKeyCopied(true)}
            data-testid="generated-apikey"
          />
        </Col>
        <Col span={5}>
          <CopyToClipboard onCopy={() => setIsAPIKeyCopied(true)} text={apiKey}>
            <Button
              block
              type="primary"
              shape="round"
              data-testid="copy-generated-apikey"
              className="mwi-100"
            >
              <FormattedMessage id="Global.copy" />
            </Button>
          </CopyToClipboard>
        </Col>
      </Row>

      <StyledAlert
        message={
          <FormattedMessage id="ApiKeys.modal.notification.apikeySecret" />
        }
        type="info"
        showIcon
      />

      {isAPIKeyCopied && (
        <StyledAlert
          message={
            <FormattedMessage id="ApiKeys.modal.notification.apiCopied" />
          }
          type="success"
          showIcon
        />
      )}

      <Row justify="center">
        <Button
          size="large"
          type="default"
          shape="round"
          disabled={!isAPIKeyCopied}
          onClick={() => onClose()}
          data-testid="close-generated-apikey"
        >
          <FormattedMessage id="Global.close" />
        </Button>
      </Row>
    </>
  );
};

export default GeneratedAPIKeyInstance;
